import { ALLOWED_QUERY_OPERATOR } from '/src/utilities/constants';
import cloneDeep from 'lodash.clonedeep';

export const initialFilters = [
    { name: 'Keyword', key: 'keyword', value: [], op: ALLOWED_QUERY_OPERATOR.equal },
    { name: 'Language', key: 'lang', value: [], op: ALLOWED_QUERY_OPERATOR.equal },
    { name: 'Type', key: 'type_id', value: [], op: ALLOWED_QUERY_OPERATOR.equal },
    { name: 'Country', key: 'location_id', value: [], op: ALLOWED_QUERY_OPERATOR.equal },
    { name: 'Industry', key: 'magnitt_industry', value: [], op: ALLOWED_QUERY_OPERATOR.equal },
    { name: 'Category', key: 'category', value: [], op: ALLOWED_QUERY_OPERATOR.equal },
    { name: 'Tag', key: 'tag', value: [], op: ALLOWED_QUERY_OPERATOR.equal },
];

export const filterReducer = (state, action) => {
    switch (action.type) {
    case 'UPDATE_STATE':
        return action.payload;
    case 'UPDATE_KEYWORD':
        const [firstItem, ...rest] = state;
        firstItem.value = action.payload;
        return [firstItem, ...rest];
    case 'RESET':
        return cloneDeep(initialFilters);
    }
};
